type getImageAltProps = {
  mobile: Queries.RESPONSIVE_IMAGEFragment['responsiveImageElements']['mobile'];
  tablet: Queries.RESPONSIVE_IMAGEFragment['responsiveImageElements']['tablet'];
  desktop: Queries.RESPONSIVE_IMAGEFragment['responsiveImageElements']['desktop'];
  fallback?: string;
};

const getImageAlt = ({ mobile, tablet, desktop, fallback }: getImageAltProps): string => {
  const [alt] = [
    mobile.value.description,
    tablet.value.description,
    desktop.value.description,
  ].filter(Boolean);

  return alt || fallback || '';
};

export default getImageAlt;
